import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";

interface LeadDetailsHeaderProps {
  title: string;
  isEditing: boolean;
  onEdit: () => void;
}

export const LeadDetailsHeader = ({ 
  title, 
  isEditing, 
  onEdit,
}: LeadDetailsHeaderProps) => {
  return (
    <DialogHeader className="flex-shrink-0">
      <div className="flex items-center gap-2">
        <DialogTitle>{title}</DialogTitle>
        {!isEditing && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onEdit}
            className="h-8 w-8"
          >
            <Pencil className="h-4 w-4" />
          </Button>
        )}
      </div>
    </DialogHeader>
  );
};